module.exports = __webpack_public_path__ + "4cb084eb655a750ba4f83f4639f1286a.pdf";